import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
// import women from "../../images/login-women.png";
import LogoImage from "../../images/MSG Notifier.svg";
import NoIndex from "../NoIndex";
import MyContext from "../../MyContext";
import GoogleOneTap from "../Googleonetab";

const LoginPage = () => {
  const { baseUrl, config, config2 } = useContext(MyContext);
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [error, setError] = useState(null);
  const [MobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [MobileNumberError, setMobileNumberError] = useState("");
  const [Otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [step, setstep] = useState(1);
  const [OTPField, setOTPField] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const navigate = useNavigate();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [Lerror, setLerror] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [LoginScreen, setLoginScreen] = useState("LOGIN");
  const [User, setUser] = useState("no user");

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  function validateInputs() {
    if (MobileNumber.length !== 10) {
      toast.error("Invalid Mobile number");
    } else if (!password) {
      toast.error("Please enter your password");
    } else {
      LoginCall();
    }
  }

  const sendOtp = async () => {
    try {
      const BankData = {
        mobile: MobileNumber,
        password: password,
        step: "1",
        otp: "",
        latitude: '',
        longitude: '',
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1/userLogin`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        setLoginScreen("OTPVERIFICATION");
        setstep(2);
        setOTPField(true);
      } else if (response.data.responseCode === "01") {
        toast.error(response.data.responseMessage);
        setError(true)
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error sending OTP");
      console.error("Error sending OTP:", error);
    }
  };

  const verifyOtp = async () => {
    try {
      const BankData = {
        mobile: MobileNumber,
        password: password,
        step: "2",
        otp: Otp.join(""),
        latitude: '',
        longitude: '',
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1/userLogin`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        sessionStorage.setItem("user", JSON.stringify(response.data.response));
        setUser(true);
        console.log("responseData:", response.data.response.userid);
        await subscriptionDetailsApi(response.data.response.userid);
        await allowedServicesAPI(response.data.response.userid);
        window.location.href = "/Dashboard";
      } else {
        toast.error(response.data.responseMessage)
      }
    } catch (error) {
      toast.error("Error verifying OTP");
      console.error("Error during OTP verification:", error);
    }
  };

  const allowedServicesAPI = async (userId) => {
    try {
      const requestBody = { userid: userId };
      const response = await axios.post(
        `${baseUrl}/api/User/getUserAccess`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        sessionStorage.setItem(
          "menuItems",
          JSON.stringify(response.data.response)
        );
      } else {
        console.log("Failed to get user access");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const subscriptionDetailsApi = async (userId) => {
    try {
      const responseBody = {
        userid: userId,
      };
      const response = await axios.post(
        `${baseUrl}/api/Entitlement/fetchSubscriptionDetails`,
        responseBody,
        config
      );
      if (response.data.responseCode === "00") {
        sessionStorage.setItem("power", "1");
        if (process.env.NODE_ENV == "development") {
          window.location.href = "/Dashboard";
        } else {
          window.location.href = "/Dashboard";
        }
      } else if (response.data.responseCode === "03") {
        if (process.env.NODE_ENV == "development") {
          window.location.href = "/Dashboard";
        } else {
          window.location.href = "/Dashboard";
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const LoginCall = async () => {
    if (MobileNumber.length !== 10) {
      toast.error("Invalid Mobile number");
      return;
    }
    if (!password) {
      toast.error("Please enter your password");
      return;
    }

    try {
      const BankData = {
        mobile: MobileNumber,
        password: password,
        latitude: latitude || "",
        longitude: longitude || "",
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v2.0/userLogin`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        sessionStorage.setItem("user", JSON.stringify(response.data.response));
        setUser(true);
        await subscriptionDetailsApi(response.data.response.userid);
        await allowedServicesAPI(response.data.response.userid);
        window.location.href = "/Dashboard";
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error during login");
      console.error("Error during login:", error);
    }
  };

  const ResendOtp = async (step) => {
    toast.info("Resending OTP...");

    try {
      const BankData = {
        mobile: MobileNumber,
        password: password,
        step: 1,
        otp: Otp.join(""),
        latitude: latitude,
        longitude: longitude,
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1/userLogin`,
        BankData,
        config2
      );
      if (step === "1") {
        toast.success(response.data.responseMessage);
        setUser(response.data.response);
        setstep(2);
        setOTPField(true);
      } else if (step === "2") {
        setUser(response.data.response);
        sessionStorage.setItem("power", "1");
        if (process.env.NODE_ENV == "development") {
          window.location.href = "/Dashboard";
        } else {
          window.location.href = "/Dashboard";
        }
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error");
      console.error("Error updating Admin login:", error);
    }
  };

  const handleOtpChange = (element, index) => {
    if (isNaN(element.value)) return false;

    const newOtp = [...Otp];
    newOtp[index] = element.value;
    setOtp(newOtp);

    if (element.value !== "" && element.nextSibling) {
      element.nextSibling.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newOtp = [...Otp];
      newOtp[index] = "";
      setOtp(newOtp);

      if (index > 0) {
        const prevInput = e.target.previousSibling;
        prevInput.focus();
      }
    }
  };

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (err) => {
          setLerror(err.message);
        }
      );
    } else {
      setError("Geolocation is not supported by your browser");
    }
  }, []);

  const [ForgetNumber, setForgetNumber] = useState('');
  const [ForgetStep, setForgetStep] = useState(1);
  const [NewPassword, setNewPassword] = useState("");
  const [ConfirmNewPassword, setConfirmNewPassword] = useState("");
  const [ForgetOtp, setForgetOtp] = useState(["", "", "", "", "", ""]);

  const handleForgotOtpChange = (element, index) => {
    if (isNaN(Number(element.value))) return;

    const newOtp = [...ForgetOtp];
    newOtp[index] = element.value;
    setForgetOtp(newOtp);

    if (element.value !== "" && element.nextElementSibling) {
      element.nextElementSibling.focus();
    }

    if (element.value === "" && element.previousElementSibling) {
      element.previousElementSibling.focus();
    }
  };

  const sendForgetOtp = async () => {
    try {
      const BankData = {
        mobile: ForgetNumber,
        newPassword: "",
        otp: "",
        step: "1",
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1.0/forgetPassword`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        setLoginScreen("OTPVERIFICATIONFORGET");
        setForgetStep(2);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error sending OTP");
      console.error("Error sending OTP:", error);
    }
  };

  const verifyForgetOtp = async () => {
    try {
      const BankData = {
        mobile: ForgetNumber,
        newPassword: "",
        otp: ForgetOtp.join(""),
        step: "2",
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1.0/forgetPassword`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        setLoginScreen("RESET_PASSWORD");
        setForgetStep(3);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error verifying OTP");
      console.error("Error verifying OTP:", error);
    }
  };

  const resetPassword = async () => {
    if (NewPassword !== ConfirmNewPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      const BankData = {
        mobile: ForgetNumber,
        newPassword: NewPassword,
        otp: ForgetOtp.join(""),
        step: "3",
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1.0/forgetPassword`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        toast.success("Password reset successfully!");
        setLoginScreen("LOGIN");
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error resetting password");
      console.error("Error resetting password:", error);
    }
  };

  function ForgotPassWord() {
    setLoginScreen("FORGOTPASSWORD")
  }

   const registerUserAfterGoogleLogin = async (googleUser) => {

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU="
    );

    const payload = {
      userid: "1",
      clientName: googleUser.name,
      password: googleUser.email,
      clientNumber: googleUser.email,
      userType: "1",
      onboardingType: "2",
      onboardedBy: "1",
      clientId: "1",
      billingName: googleUser.name,
      allowedIp: "",
      firstName: googleUser.firstName,
      lastName: googleUser.lastName,
    };

    const response = await fetch(`${baseUrl}/api/User/register`,{
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(payload),
    });

    // console.log(" HTTP STATUS:", response.status);

    const result = await response.json();
    // console.log(" REGISTER API RESPONSE:", result);

    return result;
  };

  const handleGoogleResponse = async (response) => {
    try {
      if (!response?.credential) return;

      const base64Url = response.credential.split(".")[1];
      const decodedData = JSON.parse(
        atob(base64Url.replace(/-/g, "+").replace(/_/g, "/"))
      );

      const [firstName, ...rest] = decodedData.name.split(" ");
      const lastName = rest.join(" ");

      const googleUser = {
        name: decodedData.name,
        email: decodedData.email,
        firstName,
        lastName,
      };

      const registerResult = await registerUserAfterGoogleLogin(googleUser);

      if (registerResult?.responseCode !== "00") {
        toast.error(registerResult?.responseMessage || "Registration failed");
        return;
      }
      sessionStorage.setItem("power", "1");
      const userData = registerResult.response;
      // sessionStorage.setItem("power", "1");

      sessionStorage.setItem("user", JSON.stringify(userData));

      toast.success("Login successful");

      setTimeout(() => {
        window.location.href = "/Dashboard";
      }, 1000);
    } catch (err) {
      console.error("GOOGLE LOGIN ERROR", err);
      toast.error("Something went wrong");
    }
  };

  return (
    <div className="modern-login-wrapper">
      <NoIndex />
      <ToastContainer position="top-center" />
      
      <div className="modern-login-container">
        {/* Left Side - Form Section */}
        <div className="modern-login-form-section">
          <div className="modern-login-content">
            {/* Logo */}
           <div className="modern-login-logo">
  <img src={LogoImage} alt="Logo" />
</div>



            {/* Login Flow */}
            {LoginScreen === "LOGIN" && (
              <div className="modern-login-form-wrapper">
                <div className="modern-login-header">
                  <h1 className="modern-login-title">Welcome Back</h1>
                  <p className="modern-login-subtitle">Sign in to continue to Message Notifier</p>
                </div>

                <div className="modern-login-form">
                  <div className="modern-input-wrapper">
                    <label className="modern-input-label">Phone Number</label>
                    <div className="modern-phone-input-group">
                      <select className="modern-country-code">
                        <option value="+91">IN +91</option>
                      </select>
                      <input
                        type="tel"
                        className={`modern-input ${error ? "modern-input-error" : ""}`}
                        placeholder="Enter your phone number"
                        value={MobileNumber}
                        onChange={(e) => setMobileNumber(e.target.value)}
                        maxLength="10"
                      />
                    </div>
                  </div>

                  <div className="modern-input-wrapper">
                    <label className="modern-input-label">Password</label>
                    <div className="modern-password-wrapper">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="modern-input"
                        placeholder="Enter your password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      <button
                        type="button"
                        className="modern-password-toggle"
                        onClick={togglePasswordVisibility}
                      >
                        {showPassword ? (
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                            <line x1="1" y1="1" x2="23" y2="23"></line>
                          </svg>
                        ) : (
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                          </svg>
                        )}
                      </button>
                    </div>
                  </div>

                  <div className="modern-checkbox-wrapper">
                    <label className="modern-checkbox-label">
                      <input
                        type="checkbox"
                        checked={showPassword}
                        onChange={togglePasswordVisibility}
                        className="modern-checkbox"
                      />
                      <span>Show Password</span>
                    </label>
                  </div>

                  <button 
                    type="button" 
                    onClick={validateInputs} 
                    className="modern-primary-button"
                  >
                    Sign In
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                      <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                  </button>

                  <button 
                    type="button" 
                    className="modern-text-button" 
                    onClick={() => setLoginScreen("FORGOTPASSWORD")}
                  >
                    Forgot Password?
                  </button>
                </div>
              </div>
            )}

          <div className="mt-1">
            <GoogleOneTap onSuccess={handleGoogleResponse} />
          </div>

            {/* OTP Verification */}
            {LoginScreen === "OTPVERIFICATION" && (
              <div className="modern-login-form-wrapper">
                <div className="modern-login-header">
                  <button 
                    className="modern-back-button"
                    onClick={() => setLoginScreen("LOGIN")}
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <line x1="19" y1="12" x2="5" y2="12"></line>
                      <polyline points="12 19 5 12 12 5"></polyline>
                    </svg>
                  </button>
                  <h1 className="modern-login-title">Verify OTP</h1>
                  <p className="modern-login-subtitle">Enter the 6-digit code sent to your phone</p>
                </div>

                <div className="modern-login-form">
                  <div className="modern-otp-container">
                    {Otp.map((data, index) => (
                      <input
                        key={index}
                        className="modern-otp-input"
                        type="text"
                        inputMode="numeric"
                        maxLength="1"
                        value={data}
                        onChange={(e) => handleOtpChange(e.target, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                      />
                    ))}
                  </div>

                  <button 
                    type="button" 
                    onClick={verifyOtp} 
                    className="modern-primary-button"
                  >
                    Verify & Continue
                  </button>

                  <button 
                    type="button" 
                    onClick={ResendOtp} 
                    className="modern-text-button"
                  >
                    Didn't receive code? Resend
                  </button>
                </div>
              </div>
            )}

            {/* Forgot Password */}
            {LoginScreen === "FORGOTPASSWORD" && (
              <div className="modern-login-form-wrapper">
                <div className="modern-login-header">
                  <button 
                    className="modern-back-button"
                    onClick={() => setLoginScreen("LOGIN")}
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <line x1="19" y1="12" x2="5" y2="12"></line>
                      <polyline points="12 19 5 12 12 5"></polyline>
                    </svg>
                  </button>
                  <h1 className="modern-login-title">Forgot Password?</h1>
                  <p className="modern-login-subtitle">Enter your phone number to receive OTP</p>
                </div>

                <div className="modern-login-form">
                  <div className="modern-input-wrapper">
                    <label className="modern-input-label">Phone Number</label>
                    <div className="modern-phone-input-group">
                      <select className="modern-country-code">
                        <option value="+91">IN +91</option>
                      </select>
                      <input
                        type="tel"
                        className={`modern-input ${error ? "modern-input-error" : ""}`}
                        placeholder="Enter your phone number"
                        value={ForgetNumber}
                        onChange={(e) => setForgetNumber(e.target.value)}
                        maxLength="10"
                      />
                    </div>
                  </div>

                  <button 
                    type="button" 
                    onClick={sendForgetOtp} 
                    className="modern-primary-button"
                  >
                    Send OTP
                  </button>
                </div>
              </div>
            )}

            {/* OTP Verification for Forgot Password */}
            {LoginScreen === "OTPVERIFICATIONFORGET" && (
              <div className="modern-login-form-wrapper">
                <div className="modern-login-header">
                  <button 
                    className="modern-back-button"
                    onClick={() => setLoginScreen("FORGOTPASSWORD")}
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <line x1="19" y1="12" x2="5" y2="12"></line>
                      <polyline points="12 19 5 12 12 5"></polyline>
                    </svg>
                  </button>
                  <h1 className="modern-login-title">Verify OTP</h1>
                  <p className="modern-login-subtitle">Enter the code sent to {ForgetNumber}</p>
                </div>

                <div className="modern-login-form">
                  <div className="modern-otp-container">
                    {ForgetOtp.map((data, index) => (
                      <input
                        key={index}
                        className="modern-otp-input"
                        type="text"
                        inputMode="numeric"
                        maxLength="1"
                        value={data}
                        onChange={(e) => handleForgotOtpChange(e.target, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                      />
                    ))}
                  </div>

                  <button 
                    type="button" 
                    onClick={verifyForgetOtp} 
                    className="modern-primary-button"
                  >
                    Verify OTP
                  </button>
                </div>
              </div>
            )}

            {/* Reset Password */}
            {LoginScreen === "RESET_PASSWORD" && (
              <div className="modern-login-form-wrapper">
                <div className="modern-login-header">
                  <h1 className="modern-login-title">Reset Password</h1>
                  <p className="modern-login-subtitle">Create a new secure password</p>
                </div>

                <div className="modern-login-form">
                  <div className="modern-input-wrapper">
                    <label className="modern-input-label">New Password</label>
                    <input
                      type="password"
                      className="modern-input"
                      placeholder="Enter new password"
                      value={NewPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                  </div>

                  <div className="modern-input-wrapper">
                    <label className="modern-input-label">Confirm Password</label>
                    <input
                      type="password"
                      className="modern-input"
                      placeholder="Confirm new password"
                      value={ConfirmNewPassword}
                      onChange={(e) => setConfirmNewPassword(e.target.value)}
                    />
                  </div>

                  <button 
                    type="button" 
                    onClick={resetPassword} 
                    className="modern-primary-button"
                  >
                    Reset Password
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Right Side - Image Section */}
        <div className="modern-login-image-section">
          <div className="modern-login-image-overlay"></div>
          {/* <img src={women} alt="Business professional" className="modern-login-image" /> */}
          <div className="modern-login-image-content">
            <h2>Secure & Reliable</h2>
            <p>Experience seamless message notifications with enterprise-grade security</p>
          </div>
        </div>
      </div>

      <style jsx>{`
        /* Modern Login Page Styles */

        .modern-login-wrapper {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          padding: 20px;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
        }

        .modern-login-container {
          display: flex;
          max-width: 1200px;
          width: 100%;
          background: white;
          border-radius: 24px;
          overflow: hidden;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
          min-height: 600px;
        }

        .modern-login-logo img {
  height: 150px;
  width: 150px;  
}
 
        .modern-login-form-section {
          flex: 1;
          padding: 60px 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #ffffff;
        }

        .modern-login-content {
          width: 100%;
          max-width: 420px;
        }

        .modern-login-logo {
          margin-bottom: 40px;
        }

        .modern-login-logo img {
          transition: transform 0.3s ease;
        }

        .modern-login-logo img:hover {
          transform: scale(1.05);
        }

        .modern-login-form-wrapper {
          animation: fadeInUp 0.6s ease-out;
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .modern-login-header {
          margin-bottom: 40px;
          position: relative;
        }

        .modern-back-button {
          position: absolute;
          left: -40px;
          top: 0;
          background: #f3f4f6;
          border: none;
          width: 36px;
          height: 36px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s ease;
          color: #374151;
        }

        .modern-back-button:hover {
          background: #e5e7eb;
          transform: translateX(-4px);
        }

        .modern-login-title {
          font-size: 32px;
          font-weight: 700;
          color: #1f2937;
          margin: 0 0 8px 0;
          line-height: 1.2;
        }

        .modern-login-subtitle {
          font-size: 15px;
          color: #6b7280;
          margin: 0;
          line-height: 1.5;
        }

        .modern-login-form {
          display: flex;
          flex-direction: column;
          gap: 24px;
        }

        .modern-input-wrapper {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .modern-input-label {
          font-size: 14px;
          font-weight: 600;
          color: #374151;
          margin: 0;
        }

        .modern-input {
          width: 100%;
          padding: 14px 16px;
          font-size: 15px;
          border: 2px solid #e5e7eb;
          border-radius: 12px;
          outline: none;
          transition: all 0.3s ease;
          background: #ffffff;
          color: #1f2937;
          font-family: inherit;
        }

        .modern-input:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
        }

        .modern-input::placeholder {
          color: #9ca3af;
        }

        .modern-input-error {
          border-color: #ef4444;
        }

        .modern-input-error:focus {
          border-color: #ef4444;
          box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.1);
        }

        .modern-phone-input-group {
          display: flex;
          gap: 12px;
        }

        .modern-country-code {
          padding: 9px 12px;
          font-size: 15px;
          border: 2px solid #e5e7eb;
          border-radius: 12px;
          outline: none;
          transition: all 0.3s ease;
          background: #ffffff;
          color: #1f2937;
          font-family: inherit;
          cursor: pointer;
          min-width: 95px;
        }

        .modern-country-code:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
        }

        .modern-password-wrapper {
          position: relative;
        }

        .modern-password-toggle {
          position: absolute;
          right: 16px;
          top: 50%;
          transform: translateY(-50%);
          background: none;
          border: none;
          cursor: pointer;
          color: #6b7280;
          padding: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: color 0.3s ease;
        }

        .modern-password-toggle:hover {
          color: #374151;
        }

        .modern-checkbox-wrapper {
          display: flex;
          align-items: center;
        }
          .modern-checkbox-label {
          display: flex;
          align-items: center;
          gap: 8px;
          cursor: pointer;
          font-size: 14px;
          color: #6b7280;
          user-select: none;
        }

        .modern-checkbox {
          width: 18px;
          height: 18px;
          cursor: pointer;
          accent-color: #667eea;
        }

        .modern-primary-button {
          width: 100%;
          padding: 14px 24px;
          font-size: 16px;
          font-weight: 600;
          color: white;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border: none;
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
        }

        .modern-primary-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
        }

        .modern-primary-button:active {
          transform: translateY(0);
        }

        .modern-text-button {
          background: none;
          border: none;
          color: #667eea;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          padding: 8px;
          transition: all 0.3s ease;
          text-align: center;
        }

        .modern-text-button:hover {
          color: #764ba2;
          text-decoration: underline;
        }

        .modern-otp-container {
          display: flex;
          gap: 12px;
          justify-content: center;
          margin: 20px 0;
        }

        .modern-otp-input {
          width: 56px;
          height: 56px;
          text-align: center;
          font-size: 24px;
          font-weight: 600;
          border: 2px solid #e5e7eb;
          border-radius: 12px;
          outline: none;
          transition: all 0.3s ease;
          color: #1f2937;
          caret-color: #667eea;
        }

        .modern-otp-input:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
          transform: scale(1.05);
        }

        .modern-login-image-section {
          flex: 1;
          position: relative;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }

        .modern-login-image-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, rgba(102, 126, 234, 0.9) 0%, rgba(118, 75, 162, 0.9) 100%);
          z-index: 1;
        }

        .modern-login-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }

        .modern-login-image-content {
          position: absolute;
          bottom: 60px;
          left: 60px;
          right: 60px;
          z-index: 2;
          color: white;
          animation: fadeIn 1s ease-out;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        .modern-login-image-content h2 {
          font-size: 36px;
          font-weight: 700;
          margin: 0 0 12px 0;
          line-height: 1.2;
        }

        .modern-login-image-content p {
          font-size: 18px;
          margin: 0;
          opacity: 0.95;
          line-height: 1.5;
        }

        @media (max-width: 1024px) {
          .modern-login-form-section {
            padding: 40px 50px;
          }
          
          .modern-login-image-content {
            bottom: 40px;
            left: 40px;
            right: 40px;
          }
          
          .modern-login-image-content h2 {
            font-size: 28px;
          }
          
          .modern-login-image-content p {
            font-size: 16px;
          }
        }

        @media (max-width: 768px) {
          .modern-login-container {
            flex-direction: column;
            border-radius: 16px;
          }
          
          .modern-login-form-section {
            padding: 40px 30px;
          }
          
          .modern-login-image-section {
            min-height: 200px;
            order: -1;
          }
          
          .modern-login-image-content {
            bottom: 30px;
            left: 30px;
            right: 30px;
          }
          
          .modern-login-image-content h2 {
            font-size: 24px;
          }
          
          .modern-login-image-content p {
            font-size: 14px;
          }
          
          .modern-login-title {
            font-size: 28px;
          }
          
          .modern-back-button {
            left: 0;
            position: static;
            margin-bottom: 16px;
          }
          
          .modern-otp-container {
            gap: 8px;
          }
          
          .modern-otp-input {
            width: 48px;
            height: 48px;
            font-size: 20px;
          }
        }

        @media (max-width: 480px) {
          .modern-login-wrapper {
            padding: 10px;
          }
          
          .modern-login-form-section {
            padding: 30px 20px;
          }
          
          .modern-login-title {
            font-size: 24px;
          }
          
          .modern-login-subtitle {
            font-size: 14px;
          }
          
          .modern-otp-container {
            gap: 6px;
          }
          
          .modern-otp-input {
            width: 42px;
            height: 42px;
            font-size: 18px;
          }
          
          .modern-phone-input-group {
            gap: 8px;
          }
          
          .modern-country-code {
            min-width: 90px;
            font-size: 14px;
          }
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }

        .modern-loading {
          display: inline-block;
          width: 20px;
          height: 20px;
          border: 3px solid rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          border-top-color: white;
          animation: spin 0.8s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default LoginPage;